'use client';

import { createContext, useContext, type PropsWithChildren } from 'react';

type NodeContextValue = {
  path: string;
};

// NodeContext is used to wrap each rendered Component
// with the data for the current node being rendered
export const NodeContext = createContext<NodeContextValue | undefined>(undefined);

type Props = {
  path: string;
};

export function NodeContextProvider({ children, path }: PropsWithChildren<Props>) {
  return <NodeContext.Provider value={{ path }}>{children}</NodeContext.Provider>;
}

export const useNodeContext = () => {
  const nodeContext = useContext(NodeContext);
  return nodeContext;
};
